import {useCallback, useState} from "react";
import ExpensesHeader from "./subcomponents/expenses_header/ExpensesHeader";
import ExpensesMenu from "./subcomponents/expenses_menu/ExpensesMenu";
import ExpensesSalaryPayrolls from "./subcomponents/expenses_salary_payrolls/ExpensesSalaryPayrolls";
import style from './subcomponents/styles/expenses.main.module.css';
import ExpensesSettings from "./ExpensesSettings";
import ExpensesPeriodic from "./ExpensesPeriodic";
import ExpensesOne from "./ExpensesOne";
import {FEM_V} from "../../../API/API";
import FinancialDashboard from "./FinancialDashboard";
import {ConfigProvider} from "antd";
import ruRU from 'antd/locale/ru_RU';
// Константы для ключей контента
export const CONTENT_KEYS = {
    SALARY_PAYROLLS: 'salary-payrolls',
    SALARY_SETTINGS: 'salary-settings',
    EXPENSES_PERIOD: 'expenses-period',
    EXPENSES_ONE_TIME: 'expenses-one-time',
    EXPENSES_SETTINGS: 'expenses-settings',
    EXPENSES_MAIN: 'expenses-main',
    // Добавьте другие ключи по мере расширения функционала
};

const module_v = FEM_V

const Expenses = () => {
    const [contentKey, setContentKey] = useState('expenses-main');

    // Мемоизация обработчика выбора меню
    const handleMenuSelect = useCallback((key) => {
        setContentKey(key);
    }, []);

    // Функция рендера контента
    const renderContent = () => {
        switch (contentKey) {
            case CONTENT_KEYS.EXPENSES_MAIN:
                return (<ConfigProvider locale={ruRU}>
                    <FinancialDashboard/>
                </ConfigProvider>);
            case CONTENT_KEYS.SALARY_PAYROLLS:
                return <ExpensesSalaryPayrolls module_v={module_v}/>;
            case CONTENT_KEYS.SALARY_SETTINGS:
                return <div>Здесь будут отображаться настройки модуля зарплат</div>;
            case CONTENT_KEYS.EXPENSES_PERIOD:
                return <ExpensesPeriodic/>;
            case CONTENT_KEYS.EXPENSES_ONE_TIME:
                return <ExpensesOne/>;
            case CONTENT_KEYS.EXPENSES_SETTINGS:
                return <ExpensesSettings/>;
            // Добавьте другие case по мере добавления компонентов
            default:
                return null;
        }
    };

    return (
        <div>
            <ExpensesHeader module_v={module_v} header_text={'Управление расходами компании'}/>
            <div className={style.container}>
                <ExpensesMenu onSelect={handleMenuSelect}/>
            </div>
            <div className={style.content}>
                {renderContent()}
            </div>
        </div>
    );
};

export default Expenses;